import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import UnderDevelopmentRibbon from "@/components/UnderDevelopmentRibbon";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ShardaGroupPage from "@/pages/ShardaGroupPage";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="min-h-screen bg-[#040D1C]">
      <BrowserRouter>
        <ScrollToTop />
        <UnderDevelopmentRibbon />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sharda-group" element={<ShardaGroupPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a1929",
            border: "1px solid rgba(30,150,252,0.1)",
            color: "#FFFFFF",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
